import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import classes from "./OrderResult.module.css";
import shared from "./OrderShared.module.css";
import { getDataFromLocalStorage } from "../utils/orderStorage";

export default function OrderResult() {
  const navigate = useNavigate();
  const location = useLocation();
  const [orderData, setOrderData] = useState(null);
  const [customerProfile, setCustomerProfile] = useState(null);
  const [status, setStatus] = useState("success");
  const [statusMessage, setStatusMessage] = useState("");

  const isFailure = status === "failure";

  useEffect(() => {
    const requestedStatus =
      location.state?.status === "failure" ? "failure" : "success";

    const storedOrder = location.state?.currentOrder;
    const storedCustomerProfile =
      location.state?.customerProfile ||
      getDataFromLocalStorage("customerProfile");

    if (requestedStatus === "success" && !storedOrder) {
      navigate("/orders");
      return;
    }

    setStatus(requestedStatus);
    setStatusMessage(
      location.state?.message ||
        (requestedStatus === "failure"
          ? "אירעה שגיאה בשליחת הבקשה. נסה שוב מאוחר יותר."
          : "קיבלנו את בקשת ההזמנה שלך. ניצור עימך קשר."),
    );

    setOrderData(storedOrder);
    setCustomerProfile(storedCustomerProfile);
  }, [location, navigate]);

  if (!orderData && !isFailure) {
    return <div className={classes.resultContainer}>טוען...</div>;
  }

  return (
    <bdo dir="rtl">
      <div
        className={`${classes.resultContainer} ${shared.orderPageContainer}`}
      >
        <div className={`${classes.resultCard} ${shared.sectionCard}`}>
          <div className={classes.resultIcon}>{isFailure ? "⚠️" : "🎉"}</div>
          <h2 className={shared.pageTitle}>
            {isFailure ? "לא הצלחנו לשלוח את הבקשה" : "הבקשה נשלחה בהצלחה!"}
          </h2>
          <p className={shared.pageSubtitle}>{statusMessage}</p>

          {orderData && (
            <div className={`${classes.orderSummary} ${shared.sectionCard}`}>
              <div className={`${classes.summaryRow} ${shared.summaryRow}`}>
                <span
                  className={`${shared.summaryLabel} ${classes.largerText}`}
                >
                  שם:
                </span>
                <strong
                  className={`${shared.summaryValue} ${classes.largerText}`}
                >
                  {customerProfile?.name || "---"}
                </strong>
              </div>
              {customerProfile?.email && (
                <div className={`${classes.summaryRow} ${shared.summaryRow}`}>
                  <span
                    className={`${shared.summaryLabel} ${classes.largerText}`}
                  >
                    אימייל:
                  </span>
                  <strong
                    className={`${shared.summaryValue} ${classes.largerText}`}
                  >
                    {customerProfile?.email}
                  </strong>
                </div>
              )}
              {customerProfile?.phone ? (
                <div className={`${classes.summaryRow} ${shared.summaryRow}`}>
                  <span
                    className={`${shared.summaryLabel} ${classes.largerText}`}
                  >
                    טלפון:
                  </span>
                  <strong
                    className={`${shared.summaryValue} ${classes.largerText}`}
                  >
                    {customerProfile?.phone}
                  </strong>
                </div>
              ) : null}
              <div className={`${classes.summaryRow} ${shared.summaryRow}`}>
                <span
                  className={`${shared.summaryLabel} ${classes.largerText}`}
                >
                  מספר פריטים:
                </span>
                <strong
                  className={`${shared.summaryValue} ${classes.largerText}`}
                >
                  {orderData?.length || 0}
                </strong>
              </div>
            </div>
          )}

          <div className={shared.actionButtons}>
            <button
              type="button"
              className={`${shared.buttonBase} ${shared.buttonSecondary}`}
              onClick={() => navigate("/")}
            >
              חזור לדף הבית
            </button>
            <button
              type="button"
              className={`${shared.buttonBase} ${shared.buttonPrimary}`}
              onClick={() => navigate(isFailure ? "/orders/review" : "/orders")}
            >
              {isFailure ? "נסה שוב" : "הזמן שוב"}
            </button>
          </div>
        </div>
      </div>
    </bdo>
  );
}
